// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form should be used to synchronize scheduled jobs after any change on scheduled job's system property that was performed directly on the database.
    <br>
    Please clear the system cache first before synchronizing scheduled jobs, for it to fetch the changed scheduled job's system property
    Note: Keep in mind that if you will schedule a job to be earlier than that current time, job will be executed on the next day. The job will not run today.
  </span>
</div>

<button
  type="submit"
  class=" btn btn-danger"
  ng-click="\$ctrl.synchronize()">
  Synchronize
</button>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/synchronize-scheduled-jobs/synchronize-scheduled-jobs.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;